import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Avatar, Card, Col, Row , Image} from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined, DislikeOutlined, EditOutlined, EllipsisOutlined, LikeOutlined, SettingOutlined } from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import Title from "antd/es/typography/Title";
import ArrowLeft from '../../Icons/arrow-final-left-grey.png'
import ArrowRight from '../../Icons/arrow-final-right-grey.png'
import { MoreFromAuthorCard } from "../SmallComponents/SmallComponents";
import EmptyData from "../EmptyData/EmptyData";
import styles from './MultipleSlider.module.css'

function MultipleSlider(props:any) {
  const {data, loading, featured} = props;
  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [sliderData, setSliderData] = useState<any>([{}, {}, {}]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(()=>{
    if(typeof data !== 'undefined' && data !== false && data?.length > 0){
      setSliderData(data)
    }
    if (data === false || data?.length === 0){
      setSliderData([])
    }
  }, [data])
  

  useEffect(()=>{
    // console.log(sliderData, 'sliderdata')
  }, [sliderData])
  // console.log(data, 'multiple slideer')


  function SamplePrevArrow(props:any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block"}}
        id={styles.prevArrow}
        onClick={onClick}
      ><Image className={styles.sliderArrow} preview={false} src={ArrowLeft}/>
      </div>
    );
  }

  function SampleNextArrow(props:any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block"}}
        onClick={onClick}
      ><Image className={styles.sliderArrow} preview={false} src={ArrowRight}/></div>
    );
  }

  const settings = {
    dots: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    infinite: false,
    speed: 500,
    slidesToShow:  featured ? 2 : 3,
    slidesToScroll: 1,
    // variableWidth: true
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: featured ? 2 : 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
    {
      sliderData?.length > 0 ?
      
      (sliderData?.length < 3 ) && (windowWidth > 576 ) && featured  ? 
    <Row gutter={10} justify={'start'}>
            { sliderData?.map((e:any)=>(
        <MoreFromAuthorCard dataLength={sliderData?.length} loading={loading} key={e?.id} isSlider={(windowWidth > 576 )  ? false : true} url={e?.url} slug={e?.slug}  featured={featured} title={e?.title} description={e?.details?.description} featureImg={e?.thumbnail} publishDate={e?.publish_date} likes={e?.details?.likes} dislikes={e?.details?.dislikes}/>

        ))
        }
</Row> : 

      (sliderData?.length < 4 ) && (windowWidth > 576 ) && (!featured)? 
    <Row gutter={10} justify={'start'}>
            { sliderData?.map((e:any)=>(
        <MoreFromAuthorCard loading={loading} key={e?.id} isSlider={(data?.length < 4 ) && (windowWidth > 576 ) ? false : true} url={e?.url} slug={e?.slug}  featured={featured}  title={e?.title} description={e?.details?.description} featureImg={e?.thumbnail} publishDate={e?.publish_date} likes={e?.details?.likes} dislikes={e?.details?.dislikes}/>

        ))
        }
</Row> : 

    <div className="slider-container">
      <Slider {...settings}>


        { sliderData?.map((e:any)=>(
        <MoreFromAuthorCard loading={loading} id={e?.id}  featured={featured}  isSlider={(data?.length < 4 ) && (windowWidth > 576 ) ? false : true} key={e.id} totalCards={data?.length} slug={e?.slug} url={e?.url} title={e?.title} description={e?.details?.description} featureImg={e?.thumbnail} publishDate={e?.publish_date} likes={e?.details?.likes} dislikes={e?.details?.dislikes}/>

        ))
        }

      </Slider>
    </div>

:
<Row justify={"center"} align={'middle'} style={{rowGap: "20px", minHeight: "200px"}}  gutter={20}>
<EmptyData description={`No Collections`} buttonText={null} buttonOnClick={()=> console.log("")} />
</Row>
}
     </>
  );
}

export default MultipleSlider;
